module.exports = __webpack_public_path__ + "img/ethiopia.c2ec737a.svg";